// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ClBi","colMin":"styles_colMin__1Fc9l"};